(function () {
  var stage = document.getElementById('wlStage');
  var wlo = document.getElementById('wlo');

  if (stage && wlo) {
    var data = wlo.dataset;
    var pages = [
      [data.s1, 'l'], [data.s1, 'r'],
      [data.p19, null], [data.p20, null],
      [data.s2, 'l'], [data.s2, 'r']
    ];
    var cover = [data.cover, null];
    var backCover = [data.back, null];
    var spread = 0;
    var view = 'front';
    var sequence = 0;
    var timers = [];
    var busy = false;
    var gesture = null;
    var prepared = null;
    var leafVertical = 0.5;
    var leafScale = 1;
    var leafAnimation = null;
    var leafLightingAnimations = [];
    var bookPoseAnimation = null;
    var bookFloatAnimation = null;
    var bookShadowAnimation = null;
    var preloadedImages = [];
    var orbitGesture = null;
    var orbitYaw = -26;
    var orbitPitch = 0;
    var suppressStageClick = false;
    var paneL = document.getElementById('wloL');
    var paneR = document.getElementById('wloR');
    var leaf = document.getElementById('wloLeaf');
    var leafF = document.getElementById('leafF');
    var leafB = document.getElementById('leafB');
    var leafFront = leafF.parentElement;
    var leafBack = leafB.parentElement;
    var legacyLeafLight = null;
    for (var leafChildIndex = 0; leafChildIndex < leaf.children.length; leafChildIndex += 1) {
      if (leaf.children[leafChildIndex].classList.contains('wlo-leaf-light')) {
        legacyLeafLight = leaf.children[leafChildIndex];
        break;
      }
    }
    if (legacyLeafLight) {
      leafFront.appendChild(legacyLeafLight);
      leafBack.appendChild(legacyLeafLight.cloneNode(true));
    }
    var leafLights = leaf.querySelectorAll('.wlo-leaf-light');
    var gutter = document.getElementById('wloGutter');
    var flip = document.getElementById('wlFlip');
    var riffle = document.getElementById('wloRiffle');
    var controls = document.querySelectorAll('.wl-ang[data-view]');
    var lightToggle = document.getElementById('wlLightToggle');
    var lightShell = stage.closest('.wl');
    var bookPosition = stage.querySelector('.wl-b3dpos');
    var closedBook = stage.querySelector('.wl-book .b3d');
    var bookBody = stage.querySelector('.b3d-body');
    var closedShadow = stage.querySelector('.b3d-shadow');
    var compactMotion = typeof window.matchMedia === 'function' && (window.matchMedia('(max-width: 640px)').matches || window.matchMedia('(pointer: coarse)').matches);
    var wideBookLayout = typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 641px)').matches;
    var RIFFLE_COUNT = compactMotion ? 24 : 36;
    var RIFFLE_DURATION = compactMotion ? 240 : 250;
    var RIFFLE_STAGGER = compactMotion ? 84 : 68;
    var RIFFLE_TAIL = 45;
    var BOUNDARY_RIFFLE_COUNT = compactMotion ? 7 : 9;
    var OPEN_RIFFLE_DELAY = compactMotion ? 25 : 15;
    var PAGE_TURN_DURATION = compactMotion ? 600 : 620;
    var COVER_TURN_DURATION = compactMotion ? 840 : 860;
    var HANDOFF_REVEAL_DELAY = compactMotion ? 260 : 360;
    var CLOSE_COVER_OVERLAP = compactMotion ? 140 : 160;
    var PAGE_COMMIT_DELAY = compactMotion ? 34 : 28;
    var BOOK_MODE_DURATION = wideBookLayout ? 550 : 400;
    var COVER_REVEAL_DELAY = BOOK_MODE_DURATION + 20;
    var CLOSE_FADE_DELAY = compactMotion ? 42 : 52;
    var ENGINE_FADE_DURATION = compactMotion ? 140 : 180;
    var CLOSE_ENGINE_SETTLE_DELAY = 50;
    var PLACE_DURATION = compactMotion ? 980 : 1180;
    var LIFT_DURATION = compactMotion ? 920 : 1120;
    var COVER_COLLAPSE_DELAY = Math.max(0, COVER_TURN_DURATION - BOOK_MODE_DURATION - 28);
    var PAGE_EASING = 'cubic-bezier(.24,.48,.2,1)';
    var COVER_EASING = 'cubic-bezier(.32,.08,.22,1)';
    stage.style.setProperty('--riffle-duration', RIFFLE_DURATION + 'ms');
    var trackSurfaceLight = function () {};

    function later(ms, fn) {
      var current = sequence;
      timers.push(setTimeout(function () {
        if (current === sequence) fn();
      }, ms));
    }

    function beginSequence() {
      sequence += 1;
      timers.forEach(clearTimeout);
      timers = [];
      if (orbitGesture) clearOrbitGesture(orbitGesture);
      if (leafAnimation) {
        leafAnimation.cancel();
        leafAnimation = null;
      }
      leafLightingAnimations.forEach(function (animation) { animation.cancel(); });
      leafLightingAnimations = [];
      if (bookPoseAnimation) {
        bookPoseAnimation.cancel();
        bookPoseAnimation = null;
      }
      if (bookFloatAnimation) {
        bookFloatAnimation.cancel();
        bookFloatAnimation = null;
      }
      if (bookShadowAnimation) {
        bookShadowAnimation.cancel();
        bookShadowAnimation = null;
      }
      stage.removeAttribute('data-riffle');
      stage.removeAttribute('data-riffle-count');
      stage.removeAttribute('data-riffle-source');
      stage.removeAttribute('data-riffle-terminal');
      stage.removeAttribute('data-riffle-destination');
      stage.removeAttribute('data-handoff');
      stage.removeAttribute('data-placement');
      stage.removeAttribute('data-lifting');
      stage.removeAttribute('data-contact');
      stage.removeAttribute('data-closing-target');
      stage.removeAttribute('data-hover-page');
      stage.removeAttribute('data-grab-direction');
      stage.removeAttribute('data-leaf-commit');
      stage.removeAttribute('data-cover-opening');
      stage.removeAttribute('data-cover-reveal');
      stage.removeAttribute('data-cover-closing');
      stage.removeAttribute('data-cover-collapse');
      stage.classList.remove('is-dragging', 'is-grabbed', 'is-orbiting');
    }

    function setBusy(value) {
      busy = value;
      stage.setAttribute('aria-busy', value ? 'true' : 'false');
      if (lightToggle) lightToggle.disabled = value;
    }

    function setBookMode(mode) {
      stage.setAttribute('data-book-mode', mode);
      trackSurfaceLight(compactMotion ? 520 : 680);
    }

    function pageKeyFor(page) {
      var pageIndex = pages.indexOf(page);
      return page === cover ? 'cover' : page === backCover ? 'back-cover' : pageIndex >= 0 ? 'page-' + (pageIndex + 1) : 'none';
    }

    function setFace(element, page) {
      var pageKey = pageKeyFor(page);
      element.style.backgroundImage = page[0] ? "url('" + page[0] + "')" : 'none';
      element.style.backgroundSize = '';
      element.style.backgroundPosition = '';
      element.classList.toggle('half-l', page[1] === 'l');
      element.classList.toggle('half-r', page[1] === 'r');
      element.setAttribute('data-page-key', pageKey);
    }

    function setSpread(index) {
      spread = index;
      setFace(paneL, pages[index * 2]);
      setFace(paneR, pages[index * 2 + 1]);
      stage.style.setProperty('--spread', index);
      updateMeta();
    }

    function setAtlasFace(element, index) {
      var column = index % 4;
      var row = Math.floor(index / 4) % 4;
      element.classList.remove('half-l', 'half-r');
      element.style.backgroundImage = "url('" + data.riffleSrc + "')";
      element.style.backgroundSize = '400% 400%';
      element.style.backgroundPosition = (column * 100 / 3) + '% ' + (row * 100 / 3) + '%';
      element.setAttribute('data-page-key', 'atlas-' + index);
    }

    function preloadBookImages() {
      var seen = {};
      [cover, backCover, [data.riffleSrc, null]].concat(pages).forEach(function (page) {
        var source = page && page[0];
        if (!source || seen[source]) return;
        seen[source] = true;
        var image = new Image();
        image.decoding = 'async';
        var decodeEarly = source === data.riffleSrc || source === data.s1;
        if (decodeEarly) image.fetchPriority = 'high';
        image.src = source;
        if (decodeEarly && typeof image.decode === 'function') image.decode().catch(function () {});
        preloadedImages.push(image);
      });
    }

    function riffleLift(index) {
      return compactMotion ? 8 + (index % 5) * 0.8 : 7 + index % 5;
    }

    function riffleTilt(index) {
      return ((index % 7) - 3) * (compactMotion ? 0.16 : 0.12);
    }

    function riffleDelay(index) {
      var jitter = [0, 5, -4, 3, -2, 6, -3, 2];
      return index * RIFFLE_STAGGER + (compactMotion ? jitter[index % jitter.length] : 0);
    }

    function rifflePitch(index) {
      return compactMotion ? ((index % 5) - 2) * 0.38 : 0;
    }

    function riffleDrift(index) {
      return compactMotion ? ((index % 4) - 1.5) * 0.36 : 0;
    }

    function buildRiffle() {
      var fragment = document.createDocumentFragment();
      for (var index = 0; index < RIFFLE_COUNT; index += 1) {
        var sheet = document.createElement('span');
        var front = document.createElement('i');
        var back = document.createElement('i');
        sheet.className = 'wlo-riffle-leaf';
        front.className = 'wlo-riffle-front';
        back.className = 'wlo-riffle-back';
        setAtlasFace(front, (index * 5 + 3) % 16);
        setAtlasFace(back, (index * 5 + 4) % 16);
        sheet.style.setProperty('--delay', riffleDelay(index) + 'ms');
        sheet.style.setProperty('--lift', riffleLift(index) + 'px');
        sheet.style.setProperty('--tilt', riffleTilt(index) + 'deg');
        sheet.style.setProperty('--pitch', rifflePitch(index) + 'deg');
        sheet.style.setProperty('--drift', riffleDrift(index) + 'px');
        sheet.style.setProperty('--source-z', RIFFLE_COUNT - index);
        sheet.style.setProperty('--destination-z', index + 1);
        sheet.style.zIndex = String(RIFFLE_COUNT - index);
        sheet.appendChild(front);
        sheet.appendChild(back);
        fragment.appendChild(sheet);
      }
      riffle.appendChild(fragment);
      syncMotionScale();
    }

    function syncMotionScale() {
      var width = flip.getBoundingClientRect().width || 448;
      leafScale = Math.max(0.64, Math.min(1, width / 448));
      Array.prototype.forEach.call(riffle.children, function (sheet, index) {
        sheet.style.setProperty('--lift', (riffleLift(index) * leafScale).toFixed(2) + 'px');
      });
    }

    function markView(nextView) {
      view = nextView;
      controls.forEach(function (control) {
        var selected = control.getAttribute('data-view') === nextView;
        control.classList.toggle('on', selected);
        control.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      updateMeta();
    }

    function updateMeta() {
      var state = stage.getAttribute('data-state');
      var closedFacing = stage.getAttribute('data-orbit-facing') || view;
      if (state === 'open') {
        stage.setAttribute('aria-label', 'Interactive book, pages ' + (spread * 2 + 1) + ' and ' + (spread * 2 + 2) + ' of 6. Drag or swipe a page to turn it.');
      } else if (state === 'opening') {
        stage.setAttribute('aria-label', 'Opening the interactive book');
      } else if (state === 'closing') {
        stage.setAttribute('aria-label', stage.getAttribute('data-closing-target') === 'back' ? 'Closing to the back cover' : 'Returning to the front cover');
      } else if (closedFacing === 'back') {
        stage.setAttribute('aria-label', 'Back cover. Drag to rotate the book or tap it to open.');
      } else if (closedFacing === 'spine') {
        stage.setAttribute('aria-label', 'Book spine. Drag to rotate the book or tap it to open.');
      } else {
        stage.setAttribute('aria-label', 'Front cover. Drag to rotate the book or tap it to open.');
      }
    }

    function poseAngle(pose) {
      if (pose === 'spine') return 78;
      if (pose === 'back') return 154;
      if (pose === 'back-flat') return 180;
      if (pose === 'front-flat') return 0;
      return -26;
    }

    function clamp(value, minimum, maximum) {
      return Math.max(minimum, Math.min(maximum, value));
    }

    function normalizeYaw(value) {
      var normalized = value % 360;
      if (normalized > 180) normalized -= 360;
      if (normalized <= -180) normalized += 360;
      return normalized;
    }

    function nearestAngle(angle, target) {
      var result = angle;
      while (result - target > 180) result -= 360;
      while (result - target < -180) result += 360;
      return result;
    }

    function orbitFace(yaw) {
      return Math.cos(yaw * Math.PI / 180) >= 0 ? 'front' : 'back';
    }

    function isClosedState() {
      var state = stage.getAttribute('data-state');
      return state === 'front' || state === 'spine' || state === 'back';
    }

    function syncOrbitMetadata() {
      var facing = orbitFace(orbitYaw);
      stage.setAttribute('data-orbit-yaw', orbitYaw.toFixed(2));
      stage.setAttribute('data-orbit-pitch', orbitPitch.toFixed(2));
      stage.setAttribute('data-orbit-facing', facing);
      if (stage.getAttribute('data-book-mode') !== facing) setBookMode(facing);
      if (closedShadow) {
        var projected = Math.abs(Math.cos(orbitYaw * Math.PI / 180));
        closedShadow.style.width = (18 + projected * 72).toFixed(2) + '%';
      }
      updateMeta();
      trackSurfaceLight(180);
    }

    function applyOrbitPose() {
      if (!bookBody) return;
      bookBody.style.transform = 'translateZ(22px) rotateX(' + orbitPitch.toFixed(2) + 'deg) rotateY(' + orbitYaw.toFixed(2) + 'deg)';
      syncOrbitMetadata();
    }

    function resetOrbit(pose) {
      orbitYaw = poseAngle(pose);
      orbitPitch = 0;
      stage.setAttribute('data-orbit-yaw', orbitYaw.toFixed(2));
      stage.setAttribute('data-orbit-pitch', '0.00');
      stage.setAttribute('data-orbit-facing', pose === 'back' ? 'back' : pose === 'spine' ? 'spine' : 'front');
      if (bookBody) bookBody.style.transform = '';
      if (closedShadow) closedShadow.style.width = '';
      updateMeta();
    }

    function releaseOrbitCapture(current) {
      if (!current || !current.captured || !bookPosition || !bookPosition.releasePointerCapture || !bookPosition.hasPointerCapture || !bookPosition.hasPointerCapture(current.id)) return;
      bookPosition.releasePointerCapture(current.id);
    }

    function clearOrbitGesture(current) {
      orbitGesture = null;
      stage.classList.remove('is-orbiting');
      releaseOrbitCapture(current);
    }

    function translateYFromTransform(transform) {
      if (!transform || transform === 'none') return 0;
      try {
        var Matrix = window.DOMMatrixReadOnly || window.WebKitCSSMatrix;
        if (Matrix) return new Matrix(transform).m42 || 0;
      } catch (error) {
        return 0;
      }
      return 0;
    }

    function captureFloatingBook() {
      var book = closedBook;
      var shadow = closedShadow;
      var shadowStyle = shadow ? getComputedStyle(shadow) : null;
      return {
        book: book,
        shadow: shadow,
        yaw: orbitYaw,
        pitch: orbitPitch,
        y: book ? translateYFromTransform(getComputedStyle(book).transform) : 0,
        shadowTransform: shadowStyle ? shadowStyle.transform : 'translateX(-50%) translate(-16px,18px)',
        shadowOpacity: shadowStyle ? parseFloat(shadowStyle.opacity) || 0.66 : 0.66,
        shadowFilter: shadowStyle ? shadowStyle.filter : 'blur(11px)',
        shadowWidth: shadowStyle ? shadowStyle.width : '90%'
      };
    }

    function animateBookToTable(startPose, target, frozen, done) {
      var current = sequence;
      var body = bookBody;
      var book = frozen && frozen.book;
      var shadow = frozen && frozen.shadow;
      var startAngle = frozen && typeof frozen.yaw === 'number' ? frozen.yaw : poseAngle(startPose);
      var startPitch = frozen && typeof frozen.pitch === 'number' ? frozen.pitch : 0;
      var targetAngle = target === 'back' ? 180 : 0;
      startAngle = nearestAngle(startAngle, targetAngle);
      var middleAngle = startAngle + (targetAngle - startAngle) * 0.76;

      stage.setAttribute('data-placement', target);
      stage.setAttribute('data-tabletop', '');
      stage.setAttribute('data-pose', target + '-flat');

      later(Math.round(PLACE_DURATION * 0.89), function () {
        stage.removeAttribute('data-contact');
        void stage.offsetWidth;
        stage.setAttribute('data-contact', '');
        later(430, function () {
          stage.removeAttribute('data-contact');
        });
      });

      var finish = function () {
        if (current !== sequence) return;
        if (bookPoseAnimation) {
          bookPoseAnimation.cancel();
          bookPoseAnimation = null;
        }
        if (bookFloatAnimation) {
          bookFloatAnimation.cancel();
          bookFloatAnimation = null;
        }
        if (bookShadowAnimation) {
          bookShadowAnimation.cancel();
          bookShadowAnimation = null;
        }
        if (body) body.style.transform = '';
        if (shadow) shadow.style.width = '';
        if (book) book.style.transform = 'translateY(0)';
        if (done) done();
      };

      if (!body || typeof body.animate !== 'function') {
        if (body) body.style.transform = '';
        if (shadow) shadow.style.width = '';
        later(PLACE_DURATION, finish);
        return;
      }

      bookPoseAnimation = body.animate([
        { transform: 'translate3d(0,0,22px) rotateX(' + startPitch + 'deg) rotateY(' + startAngle + 'deg)', offset: 0 },
        { transform: 'translate3d(0,0,18px) rotateX(' + (startPitch * 0.72) + 'deg) rotateY(' + (startAngle + (targetAngle - startAngle) * 0.3) + 'deg)', offset: 0.27 },
        { transform: 'translate3d(0,0,5px) rotateX(' + (startPitch * 0.2) + 'deg) rotateY(' + middleAngle + 'deg)', offset: 0.7 },
        { transform: 'translate3d(0,1px,0) rotateX(0deg) rotateY(' + targetAngle + 'deg)', offset: 0.9 },
        { transform: 'translate3d(0,-.35px,.8px) rotateX(0deg) rotateY(' + targetAngle + 'deg)', offset: 0.96 },
        { transform: 'translate3d(0,0,0) rotateX(0deg) rotateY(' + targetAngle + 'deg)', offset: 1 }
      ], { duration: PLACE_DURATION, easing: 'cubic-bezier(.32,.04,.18,1)', fill: 'forwards' });
      body.style.transform = '';

      if (book) {
        bookFloatAnimation = book.animate([
          { transform: 'translateY(' + (frozen ? frozen.y : 0) + 'px)' },
          { transform: 'translateY(0)', offset: 0.34 },
          { transform: 'translateY(0)' }
        ], { duration: PLACE_DURATION, easing: 'ease-out', fill: 'forwards' });
      }
      if (shadow) {
        shadow.style.width = '';
        bookShadowAnimation = shadow.animate([
          { transform: frozen.shadowTransform, opacity: frozen.shadowOpacity, filter: frozen.shadowFilter, width: frozen.shadowWidth },
          { transform: 'translateX(-50%) translate(-14px,17px)', opacity: 0.34, filter: 'blur(14px)', width: '88%', offset: 0.18 },
          { transform: 'translateX(-50%) translate(-11px,14px)', opacity: 0.08, filter: 'blur(15px)', width: '89%', offset: 0.38 },
          { transform: 'translateX(-50%) translate(-9px,12px)', opacity: 0.035, filter: 'blur(14px)', width: '91%', offset: 0.62 },
          { transform: 'translateX(-50%) translate(-5px,7px)', opacity: 0.14, filter: 'blur(8px)', width: '98%', offset: 0.82 },
          { transform: 'translateX(-50%) translate(-3px,4px)', opacity: 0.7, filter: 'blur(1.6px)', width: '100%', offset: 0.9 },
          { transform: 'translateX(-50%) translate(-7px,8px)', opacity: 0.4, filter: 'blur(5px)', width: '100%', offset: 0.955 },
          { transform: 'translateX(-50%) translate(-4px,5px)', opacity: 0.68, filter: 'blur(2.4px)', width: '100%' }
        ], { duration: PLACE_DURATION, easing: 'cubic-bezier(.3,.04,.2,1)', fill: 'forwards' });
      }
      bookPoseAnimation.onfinish = finish;
    }

    function animateBookFromTable(target, finalView, done) {
      var current = sequence;
      var body = stage.querySelector('.b3d-body');
      var book = stage.querySelector('.wl-book .b3d');
      var shadow = stage.querySelector('.b3d-shadow');
      var startAngle = target === 'back' ? 180 : 0;
      var finalAngle = poseAngle(finalView);
      var middleAngle = startAngle + (finalAngle - startAngle) * 0.44;
      var shadowStart = shadow ? getComputedStyle(shadow) : null;
      var shadowTransform = shadowStart ? shadowStart.transform : 'translateX(-50%)';
      var shadowOpacity = shadowStart ? parseFloat(shadowStart.opacity) || 0.9 : 0.9;

      stage.setAttribute('data-lifting', finalView);
      stage.removeAttribute('data-tabletop');
      stage.setAttribute('data-pose', finalView);

      var finish = function () {
        if (current !== sequence) return;
        if (bookPoseAnimation) {
          bookPoseAnimation.cancel();
          bookPoseAnimation = null;
        }
        if (bookFloatAnimation) {
          bookFloatAnimation.cancel();
          bookFloatAnimation = null;
        }
        if (bookShadowAnimation) {
          bookShadowAnimation.cancel();
          bookShadowAnimation = null;
        }
        if (book) book.style.transform = '';
        if (done) done();
      };

      if (!body || typeof body.animate !== 'function') {
        later(LIFT_DURATION, finish);
        return;
      }

      bookPoseAnimation = body.animate([
        { transform: 'translate3d(0,0,0) rotateY(' + startAngle + 'deg)', offset: 0 },
        { transform: 'translate3d(0,1px,1px) rotateY(' + startAngle + 'deg)', offset: 0.18 },
        { transform: 'translate3d(0,0,14px) rotateY(' + middleAngle + 'deg)', offset: 0.62 },
        { transform: 'translate3d(0,0,21px) rotateY(' + finalAngle + 'deg)', offset: 0.86 },
        { transform: 'translate3d(0,0,22px) rotateY(' + finalAngle + 'deg)', offset: 1 }
      ], { duration: LIFT_DURATION, easing: 'cubic-bezier(.3,.04,.2,1)', fill: 'forwards' });

      if (shadow) {
        bookShadowAnimation = shadow.animate([
          { transform: shadowTransform, opacity: shadowOpacity, filter: 'blur(2.4px)' },
          { transform: 'translateX(-50%) translate(-11px,13px)', opacity: 0.52, filter: 'blur(8px)', offset: 0.55 },
          { transform: 'translateX(-50%) translate(-16px,18px)', opacity: 0.66, filter: 'blur(11px)' }
        ], { duration: LIFT_DURATION, easing: 'cubic-bezier(.3,.04,.2,1)', fill: 'forwards' });
      }
      bookPoseAnimation.onfinish = finish;
    }

    function leafTransform(direction, progress) {
      var angle = direction === 'forward' ? -179.85 * progress : -179.85 * (1 - progress);
      var bend = Math.sin(Math.PI * progress);
      var verticalOffset = leafVertical - 0.5;
      var tiltStrength = compactMotion ? 4.4 : 4.2;
      var pitchStrength = compactMotion ? 3.6 : 3.4;
      var liftStrength = compactMotion ? 14 : 12;
      var dropStrength = 4;
      var scaleStrength = compactMotion ? 0.04 : 0.03;
      var tilt = verticalOffset * (direction === 'forward' ? -tiltStrength : tiltStrength) * bend;
      var pitch = verticalOffset * -pitchStrength * bend;
      var lift = bend * liftStrength * leafScale;
      var drop = verticalOffset * bend * dropStrength * leafScale;
      var scale = 1 - bend * scaleStrength;
      return 'translateY(' + drop.toFixed(2) + 'px) translateZ(' + lift.toFixed(2) + 'px) rotateX(' + pitch.toFixed(2) + 'deg) rotateZ(' + tilt.toFixed(2) + 'deg) rotateY(' + angle.toFixed(2) + 'deg) scaleX(' + scale.toFixed(4) + ')';
    }

    function leafRadius(progress) {
      if (compactMotion) return '0 3% 4% 0 / 0 1.5% 2% 0';
      var bend = Math.sin(Math.PI * progress);
      var outerTop = 8;
      var outerBottom = 10;
      var curveTop = 2.5;
      var curveBottom = 3.5;
      return '0 ' + (bend * outerTop).toFixed(2) + '% ' + (bend * outerBottom).toFixed(2) + '% 0 / 0 ' + (bend * curveTop).toFixed(2) + '% ' + (bend * curveBottom).toFixed(2) + '% 0';
    }

    function leafFaceState(direction, progress) {
      var secondFace = progress >= 0.5;
      if (direction === 'forward') {
        return { front: secondFace ? 0 : 1, back: secondFace ? 1 : 0 };
      }
      return { front: secondFace ? 1 : 0, back: secondFace ? 0 : 1 };
    }

    function renderLeaf(direction, progress) {
      var bend = Math.sin(Math.PI * progress);
      var shadeStrength = lightShell && lightShell.hasAttribute('data-candlelight') ? 0.24 : 0.2;
      var faceState = leafFaceState(direction, progress);
      leaf.style.transform = leafTransform(direction, progress);
      if (!compactMotion) leaf.style.borderRadius = leafRadius(progress);
      Array.prototype.forEach.call(leafLights, function (light) {
        light.style.opacity = String(bend * shadeStrength);
      });
      gutter.style.opacity = String(0.48 - bend * 0.08);
      leafFront.style.opacity = String(faceState.front);
      leafBack.style.opacity = String(faceState.back);
    }

    function showLeaf(frontPage, backPage, direction) {
      setFace(leafF, frontPage);
      setFace(leafB, backPage);
      leaf.classList.add('is-active');
      leaf.setAttribute('data-direction', direction);
      renderLeaf(direction, 0);
    }

    function hideLeaf() {
      leaf.classList.remove('is-active');
      leaf.removeAttribute('data-direction');
      leaf.style.transform = '';
      leaf.style.borderRadius = '';
      leafFront.style.opacity = '';
      leafBack.style.opacity = '';
      Array.prototype.forEach.call(leafLights, function (light) { light.style.opacity = ''; });
      gutter.style.opacity = '';
      leafVertical = 0.5;
      prepared = null;
    }

    function prepareTurn(direction) {
      var next = spread + (direction === 'forward' ? 1 : -1);
      if (next < 0 || next > 2) return false;
      prepared = { direction: direction, from: spread, to: next, progress: 0 };
      if (direction === 'forward') {
        showLeaf(pages[spread * 2 + 1], pages[next * 2], direction);
        setFace(paneR, pages[next * 2 + 1]);
      } else {
        showLeaf(pages[next * 2 + 1], pages[spread * 2], direction);
        setFace(paneL, pages[next * 2]);
      }
      setBusy(true);
      return true;
    }

    function finishPrepared(completed) {
      var turnState = prepared;
      if (!turnState) return;
      setSpread(completed ? turnState.to : turnState.from);
      stage.setAttribute('data-leaf-commit', completed ? 'complete' : 'restore');
      later(PAGE_COMMIT_DELAY, function () {
        stage.removeAttribute('data-leaf-commit');
        hideLeaf();
        setBusy(false);
      });
    }

    function swapLeafFace(direction, goingForward) {
      if (direction === 'forward') {
        leafFront.style.opacity = goingForward ? '0' : '1';
        leafBack.style.opacity = goingForward ? '1' : '0';
      } else {
        leafBack.style.opacity = goingForward ? '0' : '1';
        leafFront.style.opacity = goingForward ? '1' : '0';
      }
    }

    function completeLeafAnimation(direction, target, current, done) {
      if (current !== sequence) return;
      renderLeaf(direction, target);
      if (leafAnimation) {
        leafAnimation.cancel();
        leafAnimation = null;
      }
      leafLightingAnimations.forEach(function (animation) { animation.cancel(); });
      leafLightingAnimations = [];
      if (done) done();
    }

    function animateLeaf(direction, from, to, duration, done, easing) {
      var current = sequence;
      var middle = (from + to) / 2;
      var animationEasing = easing || PAGE_EASING;
      var crossed = (from < 0.5 && to > 0.5) || (from > 0.5 && to < 0.5);
      var crossingDelay = crossed ? duration * Math.abs((0.5 - from) / (to - from)) : -1;

      if (typeof leaf.animate !== 'function') {
        if (crossingDelay >= 0) {
          later(crossingDelay, function () {
            swapLeafFace(direction, to > from);
          });
        }
        leaf.style.transition = 'transform ' + duration + 'ms ' + animationEasing + (compactMotion ? '' : ', border-radius ' + duration + 'ms ease');
        void leaf.offsetWidth;
        leaf.style.transform = leafTransform(direction, to);
        if (!compactMotion) leaf.style.borderRadius = leafRadius(to);
        later(duration, function () {
          leaf.style.transition = '';
          completeLeafAnimation(direction, to, current, done);
        });
        return;
      }

      var leafFrames = [
        { transform: leafTransform(direction, from), offset: 0 },
        { transform: leafTransform(direction, middle), offset: 0.5 },
        { transform: leafTransform(direction, to), offset: 1 }
      ];
      if (!compactMotion) {
        leafFrames[0].borderRadius = leafRadius(from);
        leafFrames[1].borderRadius = leafRadius(middle);
        leafFrames[2].borderRadius = leafRadius(to);
      }
      leafAnimation = leaf.animate(leafFrames, {
        duration: duration,
        easing: animationEasing,
        fill: 'forwards'
      });
      var faceFrom = leafFaceState(direction, from);
      var faceTo = leafFaceState(direction, to);
      var frontFrames = [{ opacity: faceFrom.front, offset: 0 }];
      var backFrames = [{ opacity: faceFrom.back, offset: 0 }];
      if (crossed) {
        var crossOffset = Math.abs((0.5 - from) / (to - from));
        var crossGap = Math.min(0.003, 1 / Math.max(160, duration));
        frontFrames.push({ opacity: faceFrom.front, offset: Math.max(0, crossOffset - crossGap) });
        frontFrames.push({ opacity: faceTo.front, offset: Math.min(1, crossOffset + crossGap) });
        backFrames.push({ opacity: faceFrom.back, offset: Math.max(0, crossOffset - crossGap) });
        backFrames.push({ opacity: faceTo.back, offset: Math.min(1, crossOffset + crossGap) });
      }
      frontFrames.push({ opacity: faceTo.front, offset: 1 });
      backFrames.push({ opacity: faceTo.back, offset: 1 });
      leafLightingAnimations.push(leafFront.animate(frontFrames, {
        duration: duration,
        easing: animationEasing,
        fill: 'forwards'
      }));
      leafLightingAnimations.push(leafBack.animate(backFrames, {
        duration: duration,
        easing: animationEasing,
        fill: 'forwards'
      }));
      var shadeStrength = lightShell && lightShell.hasAttribute('data-candlelight') ? 0.24 : 0.2;
      var shadeFrames = [
        { opacity: Math.sin(Math.PI * from) * shadeStrength },
        { opacity: Math.sin(Math.PI * middle) * shadeStrength, offset: 0.5 },
        { opacity: Math.sin(Math.PI * to) * shadeStrength }
      ];
      Array.prototype.forEach.call(leafLights, function (light) {
        leafLightingAnimations.push(light.animate(shadeFrames, { duration: duration, easing: animationEasing, fill: 'forwards' }));
      });
      leafLightingAnimations.push(gutter.animate([
        { opacity: 0.48 - Math.sin(Math.PI * from) * 0.08 },
        { opacity: 0.48 - Math.sin(Math.PI * middle) * 0.08, offset: 0.5 },
        { opacity: 0.48 - Math.sin(Math.PI * to) * 0.08 }
      ], { duration: duration, easing: animationEasing, fill: 'forwards' }));
      leafAnimation.onfinish = function () {
        completeLeafAnimation(direction, to, current, done);
      };
    }

    function turn(direction) {
      if (busy || stage.getAttribute('data-state') !== 'open') return;
      if (direction === 'backward' && spread === 0) {
        closeBook('front');
        return;
      }
      if (direction === 'forward' && spread === 2) {
        closeBook('back');
        return;
      }
      leafVertical = 0.5;
      syncMotionScale();
      if (!prepareTurn(direction)) return;
      animateLeaf(direction, 0, 1, PAGE_TURN_DURATION, function () {
        finishPrepared(true);
      });
    }

    function runRiffle(direction, sourcePage, terminalSourcePage, destinationPage, done, requestedCount) {
      syncMotionScale();
      var activeCount = Math.max(1, Math.min(RIFFLE_COUNT, requestedCount || RIFFLE_COUNT));
      Array.prototype.forEach.call(riffle.children, function (sheet, index) {
        var enabled = index < activeCount;
        sheet.classList.toggle('is-riffle-disabled', !enabled);
        sheet.style.setProperty('--source-z', activeCount - index);
        sheet.style.setProperty('--destination-z', index + 1);
        sheet.style.zIndex = String(activeCount - index);
        setAtlasFace(sheet.querySelector('.wlo-riffle-front'), (index * 5 + 3) % 16);
        setAtlasFace(sheet.querySelector('.wlo-riffle-back'), (index * 5 + 4) % 16);
      });
      var sourceSheet = riffle.firstElementChild;
      var destinationSheet = riffle.children[activeCount - 1];
      if (sourceSheet && destinationSheet) {
        var sourceFront = sourceSheet.querySelector('.wlo-riffle-front');
        var sourceBack = sourceSheet.querySelector('.wlo-riffle-back');
        var destinationFront = destinationSheet.querySelector('.wlo-riffle-front');
        var destinationBack = destinationSheet.querySelector('.wlo-riffle-back');
        if (direction === 'forward') {
          setFace(sourceFront, sourcePage);
          setFace(destinationFront, terminalSourcePage);
          setFace(destinationBack, destinationPage);
        } else {
          setFace(sourceBack, sourcePage);
          setFace(destinationBack, terminalSourcePage);
          setFace(destinationFront, destinationPage);
        }
      }
      stage.removeAttribute('data-riffle');
      void riffle.offsetWidth;
      stage.setAttribute('data-riffle', direction);
      stage.setAttribute('data-riffle-count', String(activeCount));
      stage.setAttribute('data-riffle-source', pageKeyFor(sourcePage));
      stage.setAttribute('data-riffle-terminal', pageKeyFor(terminalSourcePage));
      stage.setAttribute('data-riffle-destination', pageKeyFor(destinationPage));
      later(riffleTotalDuration(activeCount), function () {
        stage.removeAttribute('data-riffle');
        stage.removeAttribute('data-riffle-count');
        stage.removeAttribute('data-riffle-source');
        stage.removeAttribute('data-riffle-terminal');
        stage.removeAttribute('data-riffle-destination');
        if (done) done();
      });
    }

    function riffleTotalDuration(count) {
      var sheetCount = count || RIFFLE_COUNT;
      return RIFFLE_DURATION + (sheetCount - 1) * RIFFLE_STAGGER + RIFFLE_TAIL;
    }

    function waitForBookMode(target, done) {
      var current = sequence;
      var openBook = document.getElementById('wlo');
      var Matrix = window.DOMMatrixReadOnly || window.WebKitCSSMatrix;
      if (!openBook || !Matrix) {
        done();
        return;
      }
      var started = performance.now();
      var inspect = function (time) {
        if (current !== sequence) return;
        var width = openBook.getBoundingClientRect().width;
        var expected = width * (target === 'back' ? 0.25 : -0.25);
        var translation;
        try {
          translation = new Matrix(getComputedStyle(openBook).transform).m41;
        } catch (_) {
          done();
          return;
        }
        if (Math.abs(translation - expected) <= 0.75) {
          done();
          return;
        }
        if (time - started > BOOK_MODE_DURATION + 240) {
          openBook.style.transition = 'none';
          void openBook.offsetWidth;
          openBook.style.transition = '';
          done();
          return;
        }
        requestAnimationFrame(inspect);
      };
      requestAnimationFrame(inspect);
    }

    function revealFlip() {
      stage.setAttribute('data-flip', '');
      trackSurfaceLight(220);
    }

    function hideFlip() {
      stage.removeAttribute('data-flip');
      trackSurfaceLight(220);
    }

    function waitForClosedEngine(done) {
      var current = sequence;
      var started = performance.now();
      var inspect = function (time) {
        if (current !== sequence) return;
        var flipOpacity = flip ? parseFloat(getComputedStyle(flip).opacity) : 0;
        var closedOpacity = bookPosition ? parseFloat(getComputedStyle(bookPosition).opacity) : 1;
        var fadeSettled = flipOpacity <= 0.02 && closedOpacity >= 0.98;
        if (fadeSettled || time - started > ENGINE_FADE_DURATION + 180) {
          done();
          return;
        }
        requestAnimationFrame(inspect);
      };
      requestAnimationFrame(inspect);
    }

    function openBook(origin) {
      if (busy) return;
      beginSequence();
      var startPose = stage.getAttribute('data-pose') || origin;
      var frozen = captureFloatingBook();
      setBusy(true);
      markView('pages');
      stage.setAttribute('data-state', 'opening');
      setBookMode(origin);
      updateMeta();
      leafVertical = 0.5;
      syncMotionScale();
      if (origin === 'back') {
        setSpread(2);
        showLeaf(pages[5], backCover, 'backward');
      } else {
        setSpread(0);
        showLeaf(cover, pages[0], 'forward');
      }

      var startPageOpening = function () {
        var coverFinished = false;
        var riffleFinished = false;
        var commitStarted = false;
        var finishOpening = function () {
          if (!coverFinished || !riffleFinished || commitStarted) return;
          commitStarted = true;
          stage.setAttribute('data-cover-reveal', '');
          stage.setAttribute('data-leaf-commit', 'cover-open');
          later(PAGE_COMMIT_DELAY, function () {
            hideLeaf();
            stage.removeAttribute('data-leaf-commit');
            stage.removeAttribute('data-cover-opening');
            stage.removeAttribute('data-cover-reveal');
            stage.setAttribute('data-state', 'open');
            setBusy(false);
            updateMeta();
          });
        };
        stage.removeAttribute('data-handoff');
        stage.setAttribute('data-cover-opening', origin);
        stage.removeAttribute('data-cover-reveal');
        setBookMode('spread');
        later(COVER_REVEAL_DELAY, function () {
          stage.setAttribute('data-cover-reveal', '');
        });
        later(OPEN_RIFFLE_DELAY, function () {
          runRiffle(
            origin === 'back' ? 'reverse' : 'forward',
            origin === 'back' ? pages[4] : pages[1],
            origin === 'back' ? pages[4] : pages[1],
            origin === 'back' ? pages[5] : pages[0],
            function () {
              riffleFinished = true;
              finishOpening();
            },
            BOUNDARY_RIFFLE_COUNT
          );
        });
        animateLeaf(origin === 'back' ? 'backward' : 'forward', 0, 1, COVER_TURN_DURATION, function () {
          coverFinished = true;
          finishOpening();
        }, COVER_EASING);
      };

      animateBookToTable(startPose, origin, frozen, function () {
        stage.setAttribute('data-handoff', origin);
        revealFlip();
        later(HANDOFF_REVEAL_DELAY, function () {
          stage.removeAttribute('data-handoff');
          stage.removeAttribute('data-placement');
          startPageOpening();
        });
      });
    }

    function finishClose(target, afterPose) {
      var body = stage.querySelector('.b3d-body');
      var closeLeafRetired = false;
      var retireCloseLeaf = function () {
        if (closeLeafRetired) return;
        closeLeafRetired = true;
        hideLeaf();
      };
      if (body) body.style.transition = 'none';
      stage.setAttribute('data-pose', target + '-flat');
      if (body) {
        void body.offsetWidth;
        body.style.transition = '';
      }
      stage.setAttribute('data-handoff', target);
      var finalView = afterPose || target;
      var completeClose = function () {
        stage.setAttribute('data-state', finalView);
        stage.setAttribute('data-pose', finalView);
        stage.removeAttribute('data-handoff');
        stage.removeAttribute('data-placement');
        stage.removeAttribute('data-lifting');
        stage.removeAttribute('data-tabletop');
        stage.removeAttribute('data-closing-target');
        stage.removeAttribute('data-cover-closing');
        stage.removeAttribute('data-cover-collapse');
        markView(finalView);
        retireCloseLeaf();
        setBusy(false);
        resetOrbit(finalView);
        var book = closedBook;
        if (book) book.style.transform = '';
      };
      later(CLOSE_FADE_DELAY, function () {
        hideFlip();
        waitForClosedEngine(function () {
          retireCloseLeaf();
          later(CLOSE_ENGINE_SETTLE_DELAY, function () {
            stage.removeAttribute('data-handoff');
            animateBookFromTable(target, finalView, completeClose);
          });
        });
      });
    }

    function closeBook(target, afterPose) {
      if (busy || stage.getAttribute('data-state') !== 'open') return;
      beginSequence();
      setBusy(true);
      stage.setAttribute('data-state', 'closing');
      stage.setAttribute('data-closing-target', target);
      updateMeta();
      var riffleFinished = false;
      var coverFinished = false;
      var coverStarted = false;
      var closeRiffleCount = BOUNDARY_RIFFLE_COUNT;
      var finishClosing = function () {
        if (!riffleFinished || !coverFinished) return;
        finishClose(target, afterPose);
      };
      var startCoverClose = function () {
        if (coverStarted) return;
        coverStarted = true;
        leafVertical = 0.5;
        stage.setAttribute('data-cover-closing', target);
        stage.removeAttribute('data-cover-collapse');
        if (target === 'back') {
          setSpread(2);
          showLeaf(pages[5], backCover, 'forward');
        } else {
          setSpread(0);
          showLeaf(cover, pages[0], 'backward');
        }
        var collapseCover = function () {
          if (stage.hasAttribute('data-cover-collapse')) return;
          stage.setAttribute('data-cover-collapse', '');
          setBookMode(target);
        };
        later(COVER_COLLAPSE_DELAY, collapseCover);
        animateLeaf(target === 'back' ? 'forward' : 'backward', 0, 1, COVER_TURN_DURATION, function () {
          collapseCover();
          waitForBookMode(target, function () {
            coverFinished = true;
            finishClosing();
          });
        }, COVER_EASING);
      };
      runRiffle(
        target === 'back' ? 'forward' : 'reverse',
        target === 'back' ? pages[spread * 2 + 1] : pages[spread * 2],
        target === 'back' ? pages[5] : pages[0],
        target === 'back' ? pages[4] : pages[1],
        function () {
          riffleFinished = true;
          if (!CLOSE_COVER_OVERLAP) startCoverClose();
          finishClosing();
        },
        closeRiffleCount
      );
      if (CLOSE_COVER_OVERLAP) {
        later(Math.max(0, riffleTotalDuration(closeRiffleCount) - CLOSE_COVER_OVERLAP), startCoverClose);
      }
    }

    function selectView(nextView) {
      var state = stage.getAttribute('data-state');
      var hasFreeOrbit = bookBody && bookBody.style.transform;
      if (busy || (nextView === view && state !== 'open' && !hasFreeOrbit)) return;
      if (nextView === 'pages') {
        if (state === 'open') return;
        openBook(stage.getAttribute('data-orbit-facing') === 'back' ? 'back' : 'front');
        return;
      }
      if (state === 'open') {
        closeBook(nextView === 'back' ? 'back' : 'front', nextView === 'spine' ? 'spine' : null);
        return;
      }
      beginSequence();
      stage.removeAttribute('data-tabletop');
      stage.setAttribute('data-state', nextView);
      stage.setAttribute('data-pose', nextView);
      setBookMode(nextView === 'back' ? 'back' : 'front');
      markView(nextView);
      resetOrbit(nextView);
    }

    function gestureProgress(direction, delta, pageWidth) {
      var distance = direction === 'forward' ? -delta : delta;
      var linear = Math.max(0, Math.min(1, distance / (pageWidth * 0.88)));
      return Math.pow(linear, 0.92);
    }

    function releaseGestureCapture(current) {
      if (!current || !current.captured || !flip.releasePointerCapture || !flip.hasPointerCapture || !flip.hasPointerCapture(current.id)) return;
      flip.releasePointerCapture(current.id);
    }

    function clearGesture(current, restorePage) {
      gesture = null;
      stage.classList.remove('is-dragging', 'is-grabbed');
      stage.removeAttribute('data-grab-direction');
      stage.style.removeProperty('--edge-pull');
      trackSurfaceLight(180);
      if (restorePage && prepared) finishPrepared(false);
      releaseGestureCapture(current);
    }

    flip.addEventListener('touchstart', function (event) {
      if (stage.getAttribute('data-state') === 'open') event.preventDefault();
    }, { passive: false });
    flip.addEventListener('touchmove', function (event) {
      if (stage.getAttribute('data-state') === 'open') event.preventDefault();
    }, { passive: false });

    flip.addEventListener('pointerdown', function (event) {
      if (gesture) {
        if (event.pointerType === 'touch') clearGesture(gesture, true);
        return;
      }
      if (busy || stage.getAttribute('data-state') !== 'open' || event.button > 0 || (event.pointerType === 'touch' && event.isPrimary === false)) return;
      var rect = flip.getBoundingClientRect();
      var direction = event.clientX >= rect.left + rect.width / 2 ? 'forward' : 'backward';
      var atEdge = direction === 'forward' ? spread === 2 : spread === 0;
      var touchPointer = event.pointerType === 'touch';
      syncMotionScale();
      leafVertical = Math.max(0.08, Math.min(0.92, (event.clientY - rect.top) / rect.height));
      gesture = {
        id: event.pointerId,
        direction: direction,
        startX: event.clientX,
        startY: event.clientY,
        lastX: event.clientX,
        lastTime: performance.now(),
        velocity: 0,
        progress: 0,
        dragging: false,
        captured: false,
        atEdge: atEdge,
        pointerType: event.pointerType || 'mouse',
        travel: 0,
        tapSlop: touchPointer ? 10 : 4,
        width: rect.width / 2,
        top: rect.top,
        height: rect.height
      };
      stage.removeAttribute('data-hover-page');
      stage.setAttribute('data-grab-direction', direction);
      stage.classList.add('is-grabbed');
      if (flip.setPointerCapture) {
        try {
          flip.setPointerCapture(event.pointerId);
          gesture.captured = true;
        } catch (error) {
          gesture.captured = false;
        }
      }
    });

    flip.addEventListener('pointermove', function (event) {
      if (!gesture || gesture.id !== event.pointerId) return;
      var deltaX = event.clientX - gesture.startX;
      var deltaY = event.clientY - gesture.startY;
      var absoluteX = Math.abs(deltaX);
      var absoluteY = Math.abs(deltaY);
      var touchPointer = gesture.pointerType === 'touch';
      gesture.travel = Math.max(gesture.travel, absoluteX, absoluteY);
      if (!gesture.dragging && absoluteY > gesture.tapSlop && absoluteY > absoluteX * 1.18) {
        clearGesture(gesture, true);
        return;
      }
      var progress = gestureProgress(gesture.direction, deltaX, gesture.width);
      var horizontalIntent = absoluteX > gesture.tapSlop && absoluteX > absoluteY * 1.08 && progress > 0.025;
      if (!gesture.dragging && horizontalIntent) {
        gesture.dragging = true;
        stage.setAttribute('data-grab-direction', gesture.direction);
        stage.classList.add('is-grabbed');
        stage.classList.add('is-dragging');
        if (!prepared && !gesture.atEdge && prepareTurn(gesture.direction)) {
          prepared.progress = progress;
          renderLeaf(gesture.direction, progress);
        }
      }
      if (!gesture.dragging) return;
      event.preventDefault();
      leafVertical = Math.max(0.08, Math.min(0.92, (event.clientY - gesture.top) / gesture.height));
      var now = performance.now();
      var elapsed = Math.max(1, now - gesture.lastTime);
      gesture.velocity = (event.clientX - gesture.lastX) / elapsed;
      gesture.lastX = event.clientX;
      gesture.lastTime = now;
      gesture.progress = progress;
      if (prepared) {
        prepared.progress = progress;
        renderLeaf(gesture.direction, progress);
      } else {
        stage.style.setProperty('--edge-pull', (progress * (gesture.direction === 'forward' ? -8 : 8)).toFixed(2) + 'px');
        trackSurfaceLight(180);
      }
    });

    function endGesture(event, cancelled) {
      if (!gesture || gesture.id !== event.pointerId) return;
      var current = gesture;
      clearGesture(current, false);
      if (event.pointerType === 'touch') event.preventDefault();
      if (!current.dragging) {
        var isTap = !cancelled && current.travel <= current.tapSlop;
        if (prepared) {
          var tapTarget = isTap ? 1 : 0;
          animateLeaf(current.direction, current.progress, tapTarget, isTap ? PAGE_TURN_DURATION : 140, function () {
            finishPrepared(isTap);
          });
        } else if (isTap) {
          turn(current.direction);
        }
        return;
      }
      var forwardVelocity = current.direction === 'forward' ? -current.velocity : current.velocity;
      var touchThreshold = current.pointerType === 'touch' || current.pointerType === 'pen';
      var complete = !cancelled && (current.progress > (touchThreshold ? 0.42 : 0.48) || forwardVelocity > (touchThreshold ? 0.32 : 0.5));
      if (!prepared) {
        if (complete) {
          current.direction === 'forward' ? closeBook('back') : closeBook('front');
        }
        return;
      }
      var distance = Math.abs((complete ? 1 : 0) - current.progress);
      animateLeaf(current.direction, current.progress, complete ? 1 : 0, Math.max(touchThreshold ? 220 : 125, PAGE_TURN_DURATION * distance), function () {
        finishPrepared(complete);
      });
    }

    flip.addEventListener('pointermove', function (event) {
      if (gesture || busy || stage.getAttribute('data-state') !== 'open' || event.pointerType !== 'mouse') return;
      var rect = flip.getBoundingClientRect();
      var position = (event.clientX - rect.left) / rect.width;
      if (position > 0.62) stage.setAttribute('data-hover-page', 'forward');
      else if (position < 0.38) stage.setAttribute('data-hover-page', 'backward');
      else stage.removeAttribute('data-hover-page');
    });
    flip.addEventListener('pointerleave', function () {
      if (!gesture) stage.removeAttribute('data-hover-page');
    });

    flip.addEventListener('pointerup', function (event) {
      endGesture(event, false);
    });
    flip.addEventListener('pointercancel', function (event) {
      endGesture(event, true);
    });
    flip.addEventListener('lostpointercapture', function (event) {
      var pointerId = event.pointerId;
      setTimeout(function () {
        if (gesture && gesture.id === pointerId) clearGesture(gesture, true);
      }, 0);
    });
    window.addEventListener('blur', function () {
      if (gesture) clearGesture(gesture, true);
      if (orbitGesture) clearOrbitGesture(orbitGesture);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && gesture) clearGesture(gesture, true);
      if (document.hidden && orbitGesture) clearOrbitGesture(orbitGesture);
    });

    if (bookPosition) {
      bookPosition.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      bookPosition.addEventListener('pointerdown', function (event) {
        if (orbitGesture || busy || !isClosedState() || event.button > 0 || (event.pointerType === 'touch' && event.isPrimary === false)) return;
        orbitGesture = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startYaw: orbitYaw,
          startPitch: orbitPitch,
          dragging: false,
          captured: false,
          slop: event.pointerType === 'touch' || event.pointerType === 'pen' ? 9 : 4,
          sensitivity: compactMotion ? 0.62 : 0.48
        };
        if (bookPosition.setPointerCapture) {
          try {
            bookPosition.setPointerCapture(event.pointerId);
            orbitGesture.captured = true;
          } catch (error) {
            orbitGesture.captured = false;
          }
        }
      });

      bookPosition.addEventListener('pointermove', function (event) {
        if (!orbitGesture || orbitGesture.id !== event.pointerId) return;
        var deltaX = event.clientX - orbitGesture.startX;
        var deltaY = event.clientY - orbitGesture.startY;
        var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        if (!orbitGesture.dragging && distance <= orbitGesture.slop) return;
        if (!orbitGesture.dragging) {
          orbitGesture.dragging = true;
          suppressStageClick = true;
          stage.classList.add('is-orbiting');
        }
        event.preventDefault();
        orbitYaw = normalizeYaw(orbitGesture.startYaw + deltaX * orbitGesture.sensitivity);
        orbitPitch = clamp(orbitGesture.startPitch - deltaY * 0.22, -26, 26);
        applyOrbitPose();
      });

      var endOrbitGesture = function (event) {
        if (!orbitGesture || orbitGesture.id !== event.pointerId) return;
        var current = orbitGesture;
        var dragged = current.dragging;
        clearOrbitGesture(current);
        if (dragged) {
          suppressStageClick = true;
          trackSurfaceLight(240);
          setTimeout(function () {
            suppressStageClick = false;
          }, 500);
        }
      };

      bookPosition.addEventListener('pointerup', endOrbitGesture);
      bookPosition.addEventListener('pointercancel', endOrbitGesture);
      bookPosition.addEventListener('lostpointercapture', function (event) {
        if (orbitGesture && orbitGesture.id === event.pointerId) clearOrbitGesture(orbitGesture);
      });
    }

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        selectView(control.getAttribute('data-view'));
      });
    });

    stage.addEventListener('click', function (event) {
      if (event.target.closest('.wl-flip') || event.target.closest('.wl-light-toggle') || busy) return;
      if (suppressStageClick) {
        suppressStageClick = false;
        event.preventDefault();
        return;
      }
      var state = stage.getAttribute('data-state');
      if (state === 'front' || state === 'spine' || state === 'back') {
        openBook(stage.getAttribute('data-orbit-facing') === 'back' ? 'back' : 'front');
      }
    });

    stage.addEventListener('keydown', function (event) {
      if (event.target !== stage || busy) return;
      var state = stage.getAttribute('data-state');
      if (state === 'open' && event.key === 'ArrowRight') {
        event.preventDefault();
        turn('forward');
      } else if (state === 'open' && event.key === 'ArrowLeft') {
        event.preventDefault();
        turn('backward');
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (state === 'open') turn('forward');
        else openBook(stage.getAttribute('data-orbit-facing') === 'back' ? 'back' : 'front');
      }
    });

    if (lightToggle && lightShell) {
      var lightTrackFrame = 0;
      var lightTrackUntil = 0;
      var lightSettleTimer = 0;
      var syncRoomLight = function () {
        var shellRect = lightShell.getBoundingClientRect();
        var toggleRect = lightToggle.getBoundingClientRect();
        var lightX = toggleRect.left + toggleRect.width / 2;
        var lightY = toggleRect.top + toggleRect.height / 2;
        var mapRect;
        lightShell.style.setProperty('--lamp-room-x', lightX - shellRect.left + 'px');
        lightShell.style.setProperty('--lamp-room-y', lightY - shellRect.top + 'px');
        if (stage.hasAttribute('data-flip')) {
          mapRect = wlo.getBoundingClientRect();
        } else {
          var closedRect = stage.querySelector('.wl-b3dpos').getBoundingClientRect();
          var mode = stage.getAttribute('data-book-mode');
          mapRect = {
            left: mode === 'back' ? closedRect.left : closedRect.left - closedRect.width,
            top: closedRect.top,
            width: closedRect.width * 2,
            height: closedRect.height
          };
        }
        if (mapRect.width > 0 && mapRect.height > 0) {
          stage.style.setProperty('--surface-light-x', ((lightX - mapRect.left) / mapRect.width * 100).toFixed(3) + '%');
          stage.style.setProperty('--surface-light-y', ((lightY - mapRect.top) / mapRect.height * 100).toFixed(3) + '%');
        }
      };
      trackSurfaceLight = function (duration) {
        lightTrackUntil = Math.max(lightTrackUntil, performance.now() + (duration || 0));
        if (lightTrackFrame) return;
        var update = function (time) {
          syncRoomLight();
          if (time < lightTrackUntil) lightTrackFrame = requestAnimationFrame(update);
          else lightTrackFrame = 0;
        };
        lightTrackFrame = requestAnimationFrame(update);
      };
      var setCandlelight = function (enabled, holdMotion) {
        syncRoomLight();
        lightShell.toggleAttribute('data-candlelight', enabled);
        lightToggle.setAttribute('aria-pressed', enabled ? 'true' : 'false');
        lightToggle.setAttribute('aria-label', enabled ? 'Turn off candlelight' : 'Turn on candlelight');
        lightToggle.title = enabled ? 'Candlelight on' : 'Candlelight off';
        if (holdMotion) {
          clearTimeout(lightSettleTimer);
          setBusy(true);
          lightSettleTimer = setTimeout(function () {
            lightSettleTimer = 0;
            setBusy(false);
          }, 1070);
        }
      };
      syncRoomLight();
      window.addEventListener('resize', syncRoomLight, { passive: true });
      window.addEventListener('load', syncRoomLight, { once: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncRoomLight);
      var candlelight = false;
      try {
        candlelight = window.localStorage.getItem('mp-candlelight') === 'true';
      } catch (error) {
        candlelight = false;
      }
      setCandlelight(candlelight, false);
      lightToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (busy) return;
        candlelight = !candlelight;
        setCandlelight(candlelight, true);
        try {
          window.localStorage.setItem('mp-candlelight', candlelight ? 'true' : 'false');
        } catch (error) {
          return;
        }
      });
    }

    preloadBookImages();
    buildRiffle();
    setSpread(0);
    markView('front');
    resetOrbit('front');
    setBusy(false);
    setFace(leafF, cover);
    setFace(leafB, pages[0]);
    renderLeaf('forward', 0);
  }

  var pop = document.getElementById('wlPop');
  if (pop) {
    var closePop = function () {
      pop.remove();
    };
    pop.querySelectorAll('[data-pop-close]').forEach(function (element) {
      element.addEventListener('click', closePop);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePop();
    });
    var popButton = pop.querySelector('.wl-pop-btn');
    if (popButton) popButton.focus();
  }
})();
